import { SearchIcon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useCommandPalette } from "./CommandPaletteProvider"

export function CommandPaletteTrigger() {
	const { setOpen } = useCommandPalette()

	return (
		<Button
			variant="outline"
			size="sm"
			className="h-8 gap-2 text-muted-foreground"
			aria-label="Open command palette"
			onClick={() => setOpen(true)}
		>
			<SearchIcon className="size-3.5" />
			<span className="hidden md:inline">Search…</span>
			<kbd className="pointer-events-none hidden h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium md:inline-flex">
				⌘K
			</kbd>
		</Button>
	)
}
